var Iframe_default = {
  "iframe": "j1Y-I"
};
export {
  Iframe_default as default
};
//# sourceMappingURL=Iframe-scss.js.map
